import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RankingItem } from 'world-archery-lib';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';


export interface DocFile {
  DocumentId: number;
  FolderId: number;
  Name: string;
  FolderName: string;
  Competitions: number[];
  Tags: any[];
  MimeType: string;
  Path: string;
  URL: string;
}

/**
 * Documents files entity store
 *
 * @export
 * @class WcupRankingStore
 * @extends {FilesStore<DocFile>}
 */
export class FilesStore extends EntitiesStore<DocFile> {
  constructor(http: HttpClient) {
    super('DOC-FILE', http);

  }
  /**
  * @Override due to required mapping
  * The method for request data
  *
  * @param {ParamsType} params
  * @param {boolean} request_more
  * @memberof EntitiesStore
  */
  getRequest(params: any, request_more: boolean) {
    this.loadingRef = true;
    this.requestMore = request_more;
    return this.http.get<{ pageInfo: any, items: Array<DocFile> }>(environment.api_url,
      {
        params: new HttpParams({ fromObject: params as any })
          .append('content', this.endpoint_name)
          .append('v', '3')
          .append('RBP', 'ALL')
      }
    ).pipe(tap(next => {
      this.data = next.items;
      this.dataStream.next(next.items);
      this.pagination = next.pageInfo;
      this.loadingRef = false;
      this.requestMore = false;
    }));
  }
}
